var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"title":"批量删除"}},[_c('a-button',{directives:[{name:"tc",rawName:"v-tc",value:({ name: '批量删除' }),expression:"{ name: '批量删除' }"}],attrs:{"type":"danger","icon":"delete"},on:{"click":_vm.onbatchDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }